module.exports = __webpack_public_path__ + "static/media/tammy-dinh.1f2b68f7.jpg";